<template>
  <div>
    <div class="d-flex justify-content-end mt-4">
      <b-form-input v-model="filter" :placeholder="$t('global.search')" class="mb-3 w-25" />
    </div>
    <div class="mc-table">
      <b-table
        :items="pagedItems"
        :fields="computedFields"
        class="border border-1"
        hover
        responsive
        small
        show-empty
        :empty-text="$t('global.emptyTable')"
      >
        <template #cell(delivery_order_number)="data">
          <b-link :href="'/delivery/' + data.item.delivery_order_uuid" class="text-primary">
            {{ data.item.delivery_order_number }}
          </b-link>
        </template>
        <template #cell(min_temperature)="data"> {{ data.item.min_temperature }}°C </template>
        <template #cell(max_temperature)="data"> {{ data.item.max_temperature }}°C </template>
      </b-table>
      <div class="mc-pagination-container">
        <b-pagination
          v-model="currentPage"
          :total-rows="filteredItems.length"
          :per-page="perPage"
          class="mt-3"
        />
      </div>
    </div>
  </div>
</template>

<script>
import * as FleetHistory from '@/services/rest-api/lib/fleet-task/history'
export default {
  props: {
    alertData: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      shipments: {},
      filter: '',
      currentPage: 1,
      perPage: 10,
      fields: [
        { key: 'delivery_order_number', label: 'No. Pengiriman' },
        { key: 'min_temperature', label: 'Min. Temperatur' },
        { key: 'max_temperature', label: 'Max. Temperatur' },
      ],
    }
  },

  computed: {
    filteredItems() {
      if (!this.shipments.data) return []
      if (!this.filter) return this.shipments.data
      const keyword = this.filter.toLowerCase()
      return this.shipments.data.filter((item) =>
        item.delivery_order_number.toLowerCase().includes(keyword)
      )
    },

    pagedItems() {
      const start = (this.currentPage - 1) * this.perPage
      const end = start + this.perPage
      return this.filteredItems.slice(start, end)
    },
    computedFields() {
      const limitTemp = Number(this.splitAlertData()[4])
      const actualTemp = Number(this.splitAlertData()[5])

      return this.fields.filter((f) => {
        if (f.key === 'min_temperature') {
          return limitTemp < actualTemp
        }
        if (f.key === 'max_temperature') {
          return limitTemp > actualTemp
        }
        return true
      })
    },
  },

  mounted() {
    this.showListDO()
  },

  methods: {
    async showListDO() {
      const parts = this.alertData?.alertData
        ?.toString()
        ?.split('|')
        ?.map((s) => s.trim())
      const id = parts?.[1] || ''
      const logId = parts?.[2] || ''
      const res = await FleetHistory.showListDO(id, logId)
      this.shipments = res || {}

      const total = this.shipments?.data?.length || 0
      this.$emit('do-count', total)
    },

    splitAlertData() {
      return this.alertData?.alertData?.split('|') || []
    },
  },
}
</script>
<style lang="scss" scoped>
.mc-table {
  .mc-pagination-container {
    display: flex;
    align-items: center;
    justify-content: flex-end;
    padding: 8px 0px 8px 0px;
    width: 100%;

    ul[role='menubar'] {
      margin-bottom: 0;
    }

    @media screen and (max-width: 468px) {
      justify-content: center;
    }

    :deep(.pagination) {
      --bs-pagination-border-width: 0;
      --bs-pagination-border-radius: 100%;

      .page-link {
        padding: 4px;
        min-height: 24px;
        aspect-ratio: 1 / 1;
        border-radius: 100%;
        font-size: 12px;
      }

      .page-link.active,
      .active > .page-link {
        background-color: $mep-primary-400;
      }

      .page-item {
        &:nth-child(1),
        &:nth-child(2),
        &:nth-last-child(1),
        &:nth-last-child(2) {
          .page-link {
            display: flex;
            justify-content: center;
            align-items: center;
            font-size: 16px;
            padding-bottom: 10%;
          }
        }
      }
    }
  }
}
</style>
